export default "__VITE_ASSET__f43ed20d__"